import { ThemeColorsKeys } from '@agria/theme/src/styles/tokens/colors';

export type TopLevelNavTokens = {
  includeTopLevelNav: boolean;
  accountDivider?: boolean;
  accountIcon?: boolean;
  currentNavColor?: ThemeColorsKeys;
};

const tokens: TopLevelNavTokens = {
  includeTopLevelNav: true,
  currentNavColor: 'brandOne100',
} as const;

export default tokens;
